import React from "react";
import ScrollToTop from "../../ScrollToTop";

const TermsAndConditions = () => {
  return (
    <div className="p-10 section bg-gray-300 ">
      <ScrollToTop/>

      <div class=" text-gray-800">
            <div class="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-10">
        <h1 class="text-3xl font-bold text-gray-800">Terms and Conditions</h1>
        <p class="mt-2 text-gray-600">Effective Date: <strong>January 5, 2025</strong></p>

        <section class="mt-4">
            <h2 class="text-2xl font-semibold">Welcome to Pronttera!</h2>
            <p class="mt-2 text-gray-600">
                These Terms and Conditions (“Terms”) govern your access to and use of our website 
                <a href="https://pronttera.com" class="text-blue-500 hover:underline">https://pronttera.com</a> 
                and its subdomains (the “Website”), as well as any services offered by Pronttera (the “Services”).
            </p>
        </section>

        <section class="mt-6">
            <h2 class="text-xl font-semibold">1. Introduction</h2>
            <p class="mt-2 text-gray-600">
                The Website and all Services offered by Pronttera are owned and operated by Pronttera, having its registered office 
                at Shah Building, First Floor, Kalas, Alandi Road, Pune. These Terms apply to all visitors, users, and others who 
                access or use the Website or Services.
            </p>
        </section>

        <section class="mt-6">
            <h2 class="text-xl font-semibold">2. Eligibility</h2>
            <p class="mt-2 text-gray-600">By using our Website or Services, you confirm that:</p>
            <ul class="list-disc list-inside text-gray-600 mt-2">
                <li>You are at least 18 years of age or are using the Website under the supervision of a parent or legal guardian.</li>
                <li>You have the legal capacity to enter into a binding agreement under applicable laws.</li>
            </ul>
        </section>

        <section class="mt-6">
            <h2 class="text-xl font-semibold">3. Services Provided</h2>
            <ul class="list-disc list-inside text-gray-600 mt-2">
                <li><strong>Tailored Software Solutions:</strong> Designing scalable and future-ready software systems for businesses.</li>
                <li><strong>Collaboration Opportunities:</strong> Providing access to a tech community for collaboration and growth.</li>
                <li><strong>Technology Consultation:</strong> Offering one-on-one or team consultation sessions with industry experts.</li>
            </ul>
        </section>

        <section class="mt-6">
            <h2 class="text-xl font-semibold">4. Account Registration</h2>
            <p class="mt-2 text-gray-600">
                To access certain features of the Website or Services, you may be required to create an account. You are responsible for 
                maintaining the confidentiality of your account information and for all activities that occur under your account.
            </p>
        </section>

        <section class="mt-6">
            <h2 class="text-xl font-semibold">15. Grievance Redressal</h2>
            <p class="mt-2 text-gray-600">If you have any concerns or complaints regarding these Terms or our Services, please contact our Grievance Officer:</p>
            <ul class="list-disc list-inside text-gray-600 mt-2">
                <li><strong>Name:</strong> Adeeb Shah</li>
                <li><strong>Designation:</strong> Grievance Officer</li>
                <li><strong>Email:</strong> <a href="mailto:info@pronttera.com" class="text-blue-500 hover:underline">info@pronttera.com</a></li>
                <li><strong>Phone:</strong> +91 9834174885</li>
                <li><strong>Address:</strong> Shah Building, First Floor, Kalas, Alandi Road, Pune</li>
            </ul>
        </section>

        <section class="mt-6">
            <h2 class="text-xl font-semibold">17. Contact Us</h2>
            <p class="mt-2 text-gray-600">For any questions or concerns about these Terms, you can contact us at:</p>
            <ul class="list-disc list-inside text-gray-600 mt-2">
                <li><strong>Email:</strong> <a href="mailto:contact@pronttera.com" class="text-blue-500 hover:underline">contact@pronttera.com</a></li>
                <li><strong>Phone:</strong> +91 9834174885</li>
                <li><strong>Address:</strong> Shah Building, First Floor, Kalas, Alandi Road, Pune</li>
            </ul>
        </section>

        <p class="mt-6 text-gray-700 font-semibold">YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD THESE TERMS AND CONDITIONS AND AGREE TO BE BOUND BY THEM.</p>
    </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
